export const enum OperatingSystemType {
  MacOS = 'mac-os',
  IOS = 'i-os',
}
